import { CarrierParcelSchema } from "@redotech/redo-model/outbound-labels/parcel";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getCarrierParcels = {
  name: "getCarrierParcels" as const,
  input: zNull(),
  output: z.object({ carrierParcels: z.array(CarrierParcelSchema) }),
};
